<template>
  <div>
    <!-- 标题 -->
    <!-- <div>
      <van-nav-bar title="资讯详情" />
    </div> -->
    <!-- 内容 -->
    <div class="essay">
      <div class="essayTitle" style="text-align: center">{{ list.Title }}</div>
      <div style="display: flex; justify-content: space-between">
        <div v-if="list.AData" class="rikind">{{ list.AData }}</div>
        <div v-if="list.ADate" class="rikind">{{ list.ADate }}</div>
        <div v-if="list.Address" class="rikind">{{ list.Address }}</div>
      </div>
      <!-- <div style="display: flex; justify-content: space-between"> -->
      <div v-if="list.Host" class="rikind">主持人：{{ list.Host }}</div>
      <div v-if="list.JoinMan" class="rikind">参加人员：{{ list.JoinMan }}</div>
      <!-- </div> -->
      <!-- 轮播图 -->
      <van-swipe
        v-if="list.Imgs"
        class="homebanner"
        :autoplay="3000"
        indicator-color="white"
      >
        <van-swipe-item v-for="banner in list.Imgs.split(',')" :key="banner">
          <img
            :src="banner"
            style="height: 172px; width: 100%; object-fit: cover"
            @click="thematic(list.Imgs.split(','))"
          />
        </van-swipe-item>
      </van-swipe>
      <!-- <div v-if="list.Imgs" class="essayImg" style="width: 100%">
        <img
          style="height: 120px; width: 45%"
          v-for="(item, index) in list.Imgs.split(',')"
          :key="index"
          :src="item"
          alt=""
          @click="thematic(list.Imgs.split(','))"
        />
      </div> -->
      <!-- 内容 -->
      <div
        class="essayContent"
        v-html="list.Content"
        @click="imageEnlargement"
      ></div>
      <!-- 附件 -->
      <div
        class="video"
        style="text-align: right; margin: 30px 0"
        v-if="list.Annex"
      >
        <a
          style="font-size: 14px; color: #4f4fef"
          :href="list.Annex"
          target="_blank"
          >附件地址</a
        >
      </div>
      <!--  -->
      <!-- 视频 -->
      <div class="video" v-if="list.Video" style="text-align: center">
        <video
          style="width: 100%; height: 220px"
          :src="list.Video"
          controls="controls"
        >
          您的浏览器不支持 video 标签。
        </video>
      </div>
      <div style="float: right; text-align: right">
        <div v-if="list.Host" class="rikind">主办社区: {{ list.orgName }}</div>
        <div v-if="list.StartTime || list.EndTime" class="rikind">
          活动日期: {{ list.StartTime }} 至 {{ list.EndTime }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { WxGetPbActElegantDetail } from "@/api/RealInfo";
import { ImagePreview } from "vant";
export default {
  data() {
    return {
      list: {},
    };
  },
  methods: {
    thematic(e) {
      console.log(e);
      ImagePreview({
        images: e, // 传递的是图片集数组
        startPosition: 0, // 图片索引位置
        closeable: true, // 是否显示关了按钮
        showIndicators: true, // 是否显示轮播指示器
        loop: false, // 不设置为false,首图和尾部图不能正常加载
      });
    },
    // 富文本图片内容 点击放大
    imageEnlargement(e) {
      if (e.target.nodeName === "IMG") {
        ImagePreview({
          images: [e.target.src], // 传递的是图片集数组
          startPosition: 0, // 图片索引位置
          closeable: true, // 是否显示关了按钮
          showIndicators: true, // 是否显示轮播指示器
          loop: false, // 不设置为false,首图和尾部图不能正常加载
        });
      }
    },
    // 获取资讯详情
    getRealInfo() {
      WxGetPbActElegantDetail(this.$route.params.Id).then((res) => {
        this.list = res.data.data;
        console.log(this.list);
        // this.list.Content = this.list.Content.replace(/<.*?>/ig,"")
        // console.log(this.list.Content);
      });
    },
  },
  mounted() {
    this.getRealInfo();
  },
};
</script>
<style></style>
